import { createAction } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentScopeProfileId } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { fetchSubscriptions } from '@mews-commander/legacy-entities/src/ducks/subscriptions';
import { fetchAllChains } from '@mews-commander/legacy-entities/src/ducks/chains';
import { startEntityAdding } from '../../entityManagement/actions';
import EnterpriseBuilderScreenStep from '../EnterpriseBuilderScreenStep';
import { STEP_CHANGED, CATEGORY_SELECTED, FLOOR_SELECTED } from './types';

export const initEnterpriseBuilder = (): CommanderThunkAction => (dispatch, getState) => {
    dispatch(fetchAllChains());

    const profileId = getCurrentScopeProfileId(getState());

    dispatch(
        fetchSubscriptions({
            profileId,
            enterpriseId: {
                value: null,
            },
        })
    );
};

export const changeStep = (step: string) => createAction(STEP_CHANGED, step);

export const addNewEntity =
    (step: string, scope: string): CommanderThunkAction =>
    (dispatch) => {
        dispatch(changeStep(step));
        dispatch(startEntityAdding(scope));
    };

export const openResourceForm =
    ({ categoryId, floorId }: { categoryId: string; floorId: string }): CommanderThunkAction =>
    (dispatch) => {
        dispatch(createAction(CATEGORY_SELECTED, categoryId));
        dispatch(createAction(FLOOR_SELECTED, floorId));
        dispatch(changeStep(EnterpriseBuilderScreenStep.Resources));
    };
